var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-image-div"},[_c('div',{staticClass:"upload-image"},[_c('h1',[_vm._v("Upload Image")]),_c('FileInput')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }